import React, { useEffect, useState } from 'react';
import ReactMarkdown from 'react-markdown';
import remarkGfm from 'remark-gfm';
import './App.css';

function App() {
  const [markdown, setMarkdown] = useState('');
  
  useEffect(() => {
    fetch('/history.md')
      .then(response => {
        if (!response.ok) {
          throw new Error('Network response was not ok');
        }
        return response.text();
      })
      .then(text => setMarkdown(text))
      .catch(error => {
        console.error('Error fetching markdown:', error);
        setMarkdown('# Error\n\nFailed to load markdown content.');
      });
  }, []);

  return (
    <div className="container">
      <div className="markdown-container">
        <ReactMarkdown 
          remarkPlugins={[remarkGfm]} 
          className="markdown-content"
        >
          {markdown}
        </ReactMarkdown>
      </div>
      <footer className="footer">
        <a 
          href="https://github.com/fryholic/charlotte" 
          target="_blank" 
          rel="noopener noreferrer"
        >
          GitHub Repository
        </a>
      </footer>
    </div>
  );
}

export default App;